var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6711_32435",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6711_32435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3652 12.1928C15.3519 13.5569 11.7562 12.9089 9.4229 10.5758C7.08956 8.24271 6.44141 4.64747 7.80996 1.63869C7.88646 1.46658 7.85034 1.26472 7.71433 1.1351C7.5847 0.999111 7.3807 0.962989 7.21069 1.03948C6.22465 1.4857 5.34487 2.09341 4.60322 2.84135C2.92441 4.51786 2 6.74894 2 9.1224C2 11.4916 2.92441 13.7206 4.60322 15.4013C6.27991 17.0757 8.50911 18 10.8828 18C13.2523 18 15.4815 17.0757 17.1624 15.4013C17.9062 14.6534 18.514 13.7758 18.9602 12.7878C19.0367 12.6156 19.0006 12.418 18.871 12.2842C18.735 12.1524 18.5374 12.1121 18.3652 12.1928Z",
    fill: "url(#paint0_linear_6711_32435)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6711_32435",
    x1: 10.5,
    y1: 1,
    x2: 10.5,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D60C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46549A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.591370ab2401f27b1586118bcc6182a1.svg";
export { ForwardRef as ReactComponent };